'use client';

import { useEffect, useState } from 'react';
import GalleryList from './GalleryCardClient';
import { Gallery } from '@/types/gallery';

const getGalleryCount = (width: number) => {
  if (width >= 1025) return 4; 
  if (width >= 768) return 3;  
  return 4;                    
};

const GalleryComponent = () => {
  const [galleries, setGalleries] = useState<Gallery[]>([]);
  const [displayCount, setDisplayCount] = useState(4);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchGalleries = async () => {
      try {
        const response = await fetch('/api/galleries');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Ensure data is an array
        if (Array.isArray(data)) {
          setGalleries(data);
        } else {
          console.error('API did not return an array:', data);
          setGalleries([]);
        }
      } catch (error) {
        console.error('Fetch error:', error);
        setError(error instanceof Error ? error.message : 'Failed to fetch galleries');
        setGalleries([]);
      } finally {
        setLoading(false);
      }
    };

    fetchGalleries();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setDisplayCount(getGalleryCount(window.innerWidth));
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loading) return <div className="text-center p-8">Loading galleries...</div>;
  
  if (error) return <div className="text-center p-8 text-red-500">Error loading galleries: {error}</div>;

  // Safely slice only if galleries is an array
  const displayedGalleries = Array.isArray(galleries) ? galleries.slice(0, displayCount) : [];

  return <GalleryList galleries={displayedGalleries} />;
};

export default GalleryComponent;